angular.module('mercury.modules.time.payroll.payrun')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('Time.Payroll.PayrunOutstanding', {
    url: '/outstanding',
    templateUrl: 'modules/time/payroll/payrun/outstanding.tpl.html',
    controller: 'TimePayrollPayrunOutstandingCtrl'
  });

  $stateProvider.state('Time.Payroll.PayrunCreate', {
    url: '/create?:start&:end&:payment&:frequency',
    templateUrl: 'modules/time/payroll/payrun/edit.tpl.html',
    controller: 'TimePayrollPayrunEditCtrl',
    data: {
      menuLinkState: 'Payroll.PayrunOutstanding'
    }
  });

  $stateProvider.state('Time.Payroll.PayrunEdit', {
    url: '/edit/:id',
    templateUrl: 'modules/time/payroll/payrun/edit.tpl.html',
    controller: 'TimePayrollPayrunEditCtrl',
    data: {
      menuLinkState: 'Payroll.PayrunOutstanding'
    }
  });

  $stateProvider.state('Time.Payroll.PayrunReview', {
    url: '/review/:id',
    templateUrl: 'modules/time/payroll/payrun/review.tpl.html',
    controller: 'PayrollPayrunReviewCtrl',
    data: {
      menuLinkState: 'Payroll.PayrunOutstanding'
    }
  });

  $stateProvider.state('Time.Payroll.PayrunArchive', {
    url: '/archive?:report',
    templateUrl: 'modules/time/payroll/payrun/archive.tpl.html',
    controller: 'TimePayrollPayrunArchiveCtrl'
  });

  //React routes
  $stateProvider.state('Time.Payroll.Payruns', {
    url: '/payruns',
    controller: 'ReactCtrl'
  });
  $stateProvider.state('Time.Payroll.EditPayrun', {
    url: '/payruns/:payrunId',
    controller: 'ReactCtrl',
    data: {
      menuLinkState: 'Time.Payroll.Payruns'
    }
  });
}]);
